import styled from "styled-components";

export const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  .md-file-input {
    height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 0;
  }
`;

export const HeaderTitle = styled.div`
  float: left;
  margin: 0 0 7px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;

  .col + .col {
    margin-left: 1rem;
    flex: 1;
  }
`;
